import { faEye, faEyeSlash, faTags } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import { Button, Card, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { BasicContext } from "../../App";
import { postMethod } from "../../requests";
import { Checkbox } from "semantic-ui-react";
import $ from "jquery";

const ManageDiscountCodeVisibilityActivityModal = (props) => {
    const { t } = useTranslation();
    const { onClose, data, reloadData } = props;
    const { checkServerData, setAlerts } = useContext(BasicContext);
    const [formChanged, setFormChanged] = useState(false);
    const [blockForm, setBlockForm] = useState(false);
    const [code, setCode] = useState({
        discount_code_name: data.discount_code_name,
        discount_code_id: data.discount_code_id,
        discount_code_active: data.discount_code_active === "Y" ? true : false,
        discount_code_visible: data.discount_code_visible === "Y" ? true : false,
    });

    const submitForm = (e) => {
        e.preventDefault();
        setBlockForm(true);
        setFormChanged(false);
        setAlerts([{ variant: "info", message: t("info.editingDiscountCode") }]);
        updateDiscountCodeActivityVisibility();
    };

    const updateDiscountCodeActivityVisibility = async () => {
        const res = await postMethod("/update-discount-code-activity-visibility", { code: code });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t(`success.${res.data.code}`), fading: 1500, id: "updatedDC" }]);
            reloadData();
        } else setBlockForm(false);
    };

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>{t("codes.managectivityAndVisibility")}</Modal.Title>
            </Modal.Header>
            <Form onSubmit={submitForm} autoComplete="off">
                <Modal.Body className="p-3">
                    <Container fluid>
                        <Row>
                            <Col xs={12}>
                                <Card className="shadow-sm mb-3">
                                    <Card.Body className="p-2">
                                        <Container fluid>
                                            <Row>
                                                <Col>
                                                    <p className="text-bold mb-1">{data.discount_code_name}</p>
                                                    <p className="mb-1">
                                                        <FontAwesomeIcon icon={faTags} className="me-1 me-lg-2" />
                                                        {data.discount_value ? (
                                                            <>
                                                                {data.discount_value} {t("currency")}
                                                            </>
                                                        ) : (
                                                            <>{data.discount_rate} %</>
                                                        )}
                                                    </p>
                                                    <p>
                                                        <FontAwesomeIcon icon={data.discount_code_visible === "Y" ? faEye : faEyeSlash} className="me-1 me-lg-2" />
                                                        {t(data.discount_code_visible === "Y" ? "visible" : "invisible")}
                                                    </p>
                                                </Col>
                                                <Col className="text-end">
                                                    <p className="mb-1">
                                                        {t("used")}:{" "}
                                                        <span className="text-bold">
                                                            {data.discount_code_usage.length}
                                                            {data.discount_code_quantity && <>/{data.discount_code_quantity}</>}
                                                        </span>
                                                    </p>
                                                    <p className="mb-1 text-small">
                                                        {t("created")}: <span className="text-bold">{moment(data.discount_code_start_date).format("DD.MM.YYYY")}</span>
                                                    </p>
                                                    <p className="text-small">{t(`codes.${data.discount_multiple_usage === "Y" ? "multipleUsageCode" : "singleUsageCode"}`)}</p>
                                                </Col>
                                            </Row>
                                        </Container>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <Form.Group className="mb-3" controlId={`codeActive`}>
                                    <Checkbox
                                        toggle
                                        label={t("codes.codeIsActive")}
                                        checked={code.discount_code_active}
                                        disabled={blockForm}
                                        onChange={() => {
                                            setCode({ ...code, discount_code_active: !code.discount_code_active });
                                            $("#codeActive").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs={12}>
                                <Form.Group className="mb-3" controlId={`codeVisible`}>
                                    <Checkbox
                                        toggle
                                        label={t("codes.codeIsVisible")}
                                        checked={code.discount_code_visible}
                                        disabled={blockForm}
                                        onChange={() => {
                                            setCode({ ...code, discount_code_visible: !code.discount_code_visible });
                                            $("#codeVisible").removeClass("is-invalid");
                                            setFormChanged(true);
                                        }}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={onClose}>
                        {t("cancel")}
                    </Button>
                    <Button variant="primary" type="submit" disabled={blockForm || !formChanged}>
                        {t("saveChanges")}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ManageDiscountCodeVisibilityActivityModal;
